<template>
  <v-container>
    <v-row
      ><v-col class="text-left">
        <h1>
          {{
            $t("creator.greetings." + randomGreetingNumber, {
              name: name,
            })
          }}
        </h1>
      </v-col></v-row
    >
    <v-row
      ><v-col class="text-left">
        <h1>{{ $t("creator.dashboard.yourStories") }}</h1>
      </v-col></v-row
    >
    <v-row>
      <v-col>
        <v-sheet
          v-if="stories != undefined"
          outlined
          class="rounded-lg story-list-container pa-3"
        >
          <v-row>
            <v-col cols="auto">
              <v-chip class="px-15 contributor-count">{{
                stories.edges.length
              }}</v-chip>
            </v-col>
          </v-row>
          <v-row
            v-if="stories.edges.length == 0"
            class="fill-height text-center ma-15"
            align="center"
          >
            <v-col>
              <h1 class="mb-3">{{ $t("storyHub.noStories") }}</h1>
              <CreateStoryButton />
            </v-col>
          </v-row>
          <v-row
            class="my-0"
            v-for="story in stories.edges"
            :key="story.node._id"
          >
            <StoryListItem :story="story.node" />
            
          </v-row>
        </v-sheet>
        <div v-else-if="error != undefined">
          {{ error }}
        </div>
        <v-sheet
          v-else
          outlined
          class="rounded-lg story-list-container pa-3"
        >
          <v-skeleton-loader class="my-3" type="card"></v-skeleton-loader>
          <v-skeleton-loader class="my-3" type="card"></v-skeleton-loader>
          <v-skeleton-loader class="my-3" type="card"></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import StoryListItem from "./StoryListItem.vue"
import CreateStoryButton from "./CreateStoryButton";
import { mapGetters } from "vuex";
import StoryMutations from "@/graphql/StoryMutations";

const NUMBER_OF_GREETINGS = 11
export default {
  data() {
    return {
      error: undefined,
      randomGreetingNumber: Math.floor(Math.random() * NUMBER_OF_GREETINGS + 1),
    };
  },
  components: {
    StoryListItem,
    CreateStoryButton,
  },
  apollo: {
    stories: {
      variables() {
        return {
          userId: this.getMe.id,
        };
      },
      error(error) {
        this.error = error;
      },
      query: StoryMutations.getMyStories,
      fetchPolicy: "network-only",
    },
  },
  computed: {
    ...mapGetters("auth", ["getMe"]),
    name() {
      if (this.getMe.userProfile.firstName?.length > 0 && this.getMe.userProfile.lastName?.length > 0) {
        return this.$t('fullName', { firstName: this.getMe.userProfile.firstName, lastName: this.getMe.userProfile.lastName })
      }
      return this.getMe.userProfile.username
    },
  },
};
</script>
<style lang="scss" scoped>
.story-list-container {
  border: 2px solid var(--v-accentElement-base);
}
</style>

